import { render, staticRenderFns } from "./internal-layout.vue?vue&type=template&id=25393fc4&scoped=true"
import script from "./internal-layout.vue?vue&type=script&lang=js"
export * from "./internal-layout.vue?vue&type=script&lang=js"
import style0 from "./internal-layout.vue?vue&type=style&index=0&id=25393fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25393fc4",
  null
  
)

export default component.exports